import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { LoaderListPlaceholderComponent } from '../../shared-with-client/loader-list-placeholder/loader-list-placeholder.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-client-stores',
    templateUrl: './client-stores.component.html',
    styleUrls: ['./client-stores.component.scss'],
    imports: [
        NgIf,
        NgFor,
        LoaderListPlaceholderComponent,
        TranslatePipe,
    ],
    standalone: true
})
export class ClientStoresComponent implements OnInit {

  @Input() merchant;
  @Input() stores;
  @Output() saved = new EventEmitter;

  public loading = true;

  constructor() { }

  ngOnInit() {
    this.stores = this.merchant.stores;
    this.loading = false;
  }

  selectStore(store) {
    this.saved.emit(store);
  }

}
